import $ from 'jquery';

const tagListV2Semantics = {
    mainWrapClass: 'tag-list-v2',
    isInitializedAttribute: 'data-is-initialized',
    instanceIdAttribute: 'data-instance-id',
    elementClass: 'tag-list-v2__item',
    activeElementClass: 'tag-list-v2__item-active'
}

$(function () {

    let roots = $(`.${tagListV2Semantics.mainWrapClass}`);
    if (roots.length === 0) {
        return false;
    }
    let tagListV2 = new TagListV2();
    /**
     * Checking other instances
     */
    roots.each((index, el) => {
        let isInitialized =
            ($(el).attr(`${tagListV2Semantics.isInitializedAttribute}`) === 'true');

        if (!isInitialized) {
            tagListV2.registerInstance($(el));
            tagListV2.registerListeners($(el));
        }
    });
})

class TagListV2 {

    constructor() {
        this.pluginInstances = {};
    }

    registerInstance(el) {

        let instanceId =
            el.attr(`${tagListV2Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            let object = el.find(`.${tagListV2Semantics.mainWrapClass}`);
            el.attr(`${tagListV2Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch(e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el)
    {
        let elements = $(`.${tagListV2Semantics.mainWrapClass}[${
            tagListV2Semantics
                .instanceIdAttribute
        }="${
            el.attr(tagListV2Semantics
                .instanceIdAttribute)
        }"]`);

        elements.on(
            'click',
            `.${tagListV2Semantics.elementClass}`,
            function(e) {
                e.preventDefault();
                let current = $(e.currentTarget);
                let tagStack = [];
                let activeClass = `${tagListV2Semantics.activeElementClass}`;
                current.attr('data-is-active', current.attr('data-is-active')==="1" ? 0 : 1);
                current.toggleClass(activeClass);
                elements.find(`.${activeClass}`).each(function(index,obj){
                    tagStack.push( $(obj).data('tag'));
                });

                let url  = new URL(document.location.href);

                if (tagStack.length === 0) {
                    url.searchParams.delete('tags');
                } else {
                    let tags = tagStack.join("|");
                    url.searchParams.set('tags', tags);
                }

                url.searchParams.delete('page');
                return window.location.href = url.href;
            }
        );
    }
}

export default TagListV2;